<section class="hero" id="hero-home">
  <div class="hero__inner">
    <!-- Columna texto -->
    <div class="hero__copy">
      <span class="hero__pill">
        <span class="hero__pill-dot"></span>
        Fichaje al día · anticípate a la Inspección
      </span>

      <h1 class="hero__title">
        Todo el cumplimiento, conectado,
        <span class="hero__title-hi">por menos de lo que pagas solo por fichar</span>.
      </h1>

      <p class="hero__para">
        Fichaje y facturación en una sola plataforma, con operativos ilimitados
        y un humano que te lo monta si lo necesitas.
        <strong>No cobramos licencia por quien solo ficha.</strong>
      </p>

      <div class="hero__actions">
        <a class="hero__btn hero__btn--primary" routerLink="/prueba-sin-compromiso">
          Empieza la prueba de 14 días
        </a>
        <a class="hero__btn hero__btn--outline" routerLink="/modulos">
          Ver módulos
        </a>
      </div>

      <p class="hero__check">
        <i class="pi pi-check" aria-hidden="true"></i>
        Sin permanencia · Verifactu de serie · puesta en marcha opcional
      </p>
    </div>

    <!-- Columna puzzle + chips -->
    <div class="hero__visual">
      <app-hero-puzzle></app-hero-puzzle>

      <div class="hero-chip hero-chip--fichaje">
        <span class="hero-chip__label">Fichaje</span>
        <span class="hero-chip__value">
          <span class="hero-chip__dot" style="background: var(--ts-mod-facturacion)"></span>
          Entrada 09:02
        </span>
      </div>

      <div class="hero-chip hero-chip--inline hero-chip--facturacion">
        <span class="hero-chip__hex" style="background: var(--ts-mod-plataforma)"></span>
        Facturación
      </div>

      <div class="hero-chip hero-chip--inline hero-chip--gastos">
        <span class="hero-chip__hex" style="background: var(--ts-mod-gastos)"></span>
        Gastos con IA
      </div>
    </div>
  </div>
</section>
